import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../common/form/Input';
import { PhoneInput } from '../common/form/PhoneInput';
import { LanguageSelect } from '../common/form/LanguageSelect';
import { SUPPORTED_LANGUAGES } from '../../utils/i18n';
import { FieldGrid, LastNameLangCell, NameRow, PinRow } from './VisitorPersonFields.styles';

interface Props {
  pathPrefix?: string;
  allowedLanguages?: string[];
  onEmailBlur?: (email: string) => void | Promise<void>;
  showPin?: boolean;
  onPinBlur?: (pin: string) => void | Promise<void>;
}

export const VisitorPersonFields: FC<Props> = ({ pathPrefix, allowedLanguages, onEmailBlur, showPin, onPinBlur }) => {
  const { t } = useTranslation();
  const prefix = pathPrefix ? `${pathPrefix}.` : '';

  return (
    <FieldGrid>
      {showPin && (
        <PinRow>
          <Input
            type="number"
            name={`${prefix}pin`}
            label={t('visitation.pin')}
            autoComplete="off"
            onBlur={onPinBlur ? (e) => onPinBlur(e.target.value) : undefined}
          />
        </PinRow>
      )}
      <NameRow>
        <Input name={`${prefix}name`} label={t('user.name')} maxLength={100} required />
        <LastNameLangCell>
          <Input name={`${prefix}lastName`} label={t('user.lastName')} maxLength={100} required />
          <LanguageSelect
            name={`${prefix}language`}
            label={t('common.language')}
            languages={SUPPORTED_LANGUAGES}
            allowedLanguages={allowedLanguages}
            compact
            hideNonSelected
            required
          />
        </LastNameLangCell>
      </NameRow>
      <PhoneInput name={`${prefix}phone`} label={t('user.phone')} />
      <Input
        name={`${prefix}email`}
        label={t('user.email')}
        removeSpaces
        maxLength={100}
        onBlur={onEmailBlur ? (e) => onEmailBlur(e.target.value) : undefined}
      />
    </FieldGrid>
  );
};
